import { services } from "api/serviceConfig";
import { makeAutoObservable, reaction } from "mobx";
import { Customer } from "models/users/Customer";
import { MarvelUser } from "models/users/MarvelUser";
import { UserGroup } from "models/users/UserGroup";
import IdentityStore from "./IdentityStore";

export class GroupStore {
    constructor(identityStore: IdentityStore) {
        makeAutoObservable(this);
        this.identityStore = identityStore;

        reaction(
            () => identityStore.currentCustomer,
            () => this.setSelectedCustomer(identityStore.currentCustomer)
        );
    }

    selectedCustomer: Customer | undefined;
    identityStore: IdentityStore;
    groupsLoading = false;

    currentPage = 1;
    totalPages = 1;
    groups: UserGroup[] = [];

    addGroupSelectedCustomer: Customer | undefined;

    users: MarvelUser[] = [];
    usersLoading = false;

    get isLastPage() {
        return this.totalPages === 0 || this.currentPage === this.totalPages;
    }

    setPage = (page: number) => {
        this.currentPage = page;
    };

    movePage = (direction: "back" | "forward") => {
        direction === "back" ? this.currentPage-- : this.currentPage++;
    };

    clearPagination = () => {
        this.groups = [];
        this.currentPage = 1;
        this.totalPages = 1;
    };

    loadGroups = async () => {
        this.groupsLoading = true;

        try {
            const responsePayload = (
                this.selectedCustomer === undefined
                    ? await services.UserManagement.getGlobalGroups(5, this.currentPage)
                    : await services.UserManagement.getCustomerGroups({
                          customerId: this.selectedCustomer.id,
                          pageNumber: this.currentPage,
                          pageSize: 5,
                      })
            ).data;

            this.totalPages = responsePayload.totalPages;
            this.groups = responsePayload.items;
        } catch (error) {
            console.log(error);
        } finally {
            this.groupsLoading = false;
        }
    };

    loadUsers = async (customerId: number | undefined) => {
        this.usersLoading = true;

        try {
            const responsePayload = (
                customerId === undefined
                    ? await services.UserManagement.getGlobalUsers()
                    : await services.UserManagement.getCustomerUsers(customerId)
            ).data;

            this.users = responsePayload;
        } catch (error) {
        } finally {
            this.usersLoading = false;
        }
    };

    setSelectedCustomer = (customer: undefined | Customer) => {
        this.selectedCustomer = customer;
    };

    setSelectedCustomerByName = (name: string) => {
        if (name === "-- global --") {
            this.selectedCustomer = undefined;
        } else {
            this.selectedCustomer = this.identityStore.allCustomers.find((x) => x.name === name);
        }
    };
}
